/*
 * @Descripttion:
 * @version: v1
 * @Author: liukx
 * @Date: 2022-05-05 20:23:32
 * @LastEditors: ???
 * @LastEditTime: 2022-05-14 14:39:27
 */
import request from '@/utils/request';

export function getUserRoutes(params) {
  return request({
    url: 'auth/findAuthByUser',
    method: 'get',
    params,
  });
}


export function getUserRoutes2(params) {
  return request({
    url: "auth/findAuth",
    method: "get",
    params,
  });
}

export function loginByUsername(username, password) {
  const data = {
    username,
    password,
  };
  return request({
    url: '/login/login',
    method: 'post',
    data,
  });
}

  export function login(username, password) {
    const data = {
      username,
      password,
    };
    return request({
      url: '/login',
      method: 'post',
      data,
    });
  }

export function logout() {
  return request({
    url: '/login/logout',
    method: 'post',
  });
}

export function getUserInfo(token) {
  return request({
    url: '/user/info',
    method: 'get',
    params: { token },
  });
}

// 根据角色查询权限
export function getRoleAuthInfo(roleId) {
  return request({
    url: `/role/getRoleAuthInfo?roleId=${roleId}`,
    method: 'post',
  });
}

